import React, { useCallback, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { NotificationProvider, DialogProvider } from '@ccm-office/ccm-ui';
import { getUserConfirmation } from 'components/NavigationPrompt';
import { AppStateProvider } from 'contexts';
import { defaultMuiTheme } from 'themes';
import PrivateContent from 'components/PrivateContent';
import ErrorHandlerDialog from 'components/ErrorHandlerDialog';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { getCookie } from 'utils/cookies';

function App() {
  const ldClient = useLDClient();
  const initLD = useCallback(() => {
    const organizationName = getCookie('nep-organization');
    if (organizationName) {
      ldClient?.identify({
        key: 'example_user',
        name: organizationName,
        email: 'User@example.com',
      });
    }
  }, [ldClient]);

  useEffect(() => {
    initLD();
  }, [initLD]);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={defaultMuiTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Router getUserConfirmation={getUserConfirmation}>
            <AppStateProvider>
              <NotificationProvider>
                <DialogProvider>
                  <ErrorHandlerDialog />
                  <PrivateContent />
                </DialogProvider>
              </NotificationProvider>
            </AppStateProvider>
          </Router>
        </MuiPickersUtilsProvider>
        <CssBaseline />
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
